import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { useEffect } from "react";

export const LegalLayout = ({ title, subtitle, lastUpdated, children }) => {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "auto" });
  }, [title]);

  return (
    <main className="bg-white/60 backdrop-blur-sm">
      <div className="border-b border-sky-100/60">
        <div className="max-w-4xl mx-auto px-5 md:px-10 py-4">
          <Link
            to="/"
            className="inline-flex items-center gap-1.5 text-sm text-slate-600 hover:text-cyan-600 font-medium"
          >
            <ArrowLeft className="w-4 h-4" /> Înapoi la magazin
          </Link>
        </div>
      </div>
      <article className="max-w-4xl mx-auto px-5 md:px-10 py-12 md:py-16">
        <header className="mb-10">
          <h1 className="font-heading text-3xl md:text-5xl font-black text-slate-900 leading-tight tracking-tight">
            {title}
          </h1>
          {subtitle && (
            <p className="mt-3 text-base md:text-lg text-slate-600 leading-relaxed">
              {subtitle}
            </p>
          )}
          {lastUpdated && (
            <p className="mt-3 text-xs text-slate-500 uppercase tracking-wider">
              Actualizat: {lastUpdated}
            </p>
          )}
        </header>
        <div className="prose-legal space-y-6 text-slate-700 text-[15px] md:text-base leading-relaxed">
          {children}
        </div>
      </article>
    </main>
  );
};
